import { Link } from 'react-router';

interface SourcesFooterSectionProps {
  link?: string;
  links?: string[];
}

export default function SavingsSourcesFooterSection({
  link,
  links,
}: SourcesFooterSectionProps) {
  return (
    <div className="flex w-full flex-col">
      <p className="body2-strong">Source{link ? '' : 's'}:</p>
      {link ? (
        <Link
          to={link}
          className="link-body2 font-normal text-flexcar-neutral10 underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {link}
        </Link>
      ) : null}
      {links ? (
        <ul className="text-flexcar-neutral10">
          {links.map((link, index) => (
            <li key={`footer-link-${index}-${link}`}>
              <Link
                to={link}
                className="link-body2 font-normal text-flexcar-neutral10 underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
